class MainMenu {
    constructor(selector) {
        this.menuBar = document.querySelector(selector);
        this.active =
            (this.menuBar && this.menuBar.querySelector('.active')) ||
            undefined;

        if (!this.menuBar) return;

        window.onload = () => {
            this.calcmenuBarWidth();

            if (!this.menuBar.classList.contains('shop-header__menu--ready')) {
                let left = this.active
                    ? $(this.active).parent().position().left
                    : 0;
                $(this.menuBar).scrollLeft(left - 130);
                this.menuBar.classList.add('shop-header__menu--ready');
            }
        };

        window.addEventListener('resize', () => {
            return this.calcmenuBarWidth();
        });
    }

    calcmenuBarWidth() {
        this.menuBar.style.maxWidth = window.innerWidth - 130 + 'px';
    }
}

export const mainMenu = new MainMenu('.shop-header__menu');
